import React, { useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

// 1. Crear el Contexto
const AuthContext = React.createContext();

// 2. Crear el Hook 'useAuth'
export function useAuth() {
  return useContext(AuthContext);
}

// 3. Crear el Provider
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Escuchar cambios en el estado de autenticación
    const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {
      if (userAuth) {
        // Usuario ha iniciado sesión (desde Firebase Auth)
        // AHORA, buscar sus datos adicionales en Firestore
        const userDocRef = doc(db, "users", userAuth.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          // Usuario encontrado en Firestore, combinar datos
          const userData = userDocSnap.data();
          setCurrentUser({
            ...userAuth, // Datos de Firebase Auth (uid, email, etc.)
            ...userData, // Datos de Firestore (role, permissions, etc.)
            // (Aquí es donde deberíamos asegurarnos que 'companyId' venga)
            companyId: userData.companyId || null, 
          });
        } else {
          // Usuario autenticado pero no encontrado en Firestore (¿recién creado?)
          console.warn("Usuario autenticado pero no encontrado en Firestore:", userAuth.uid);
          setCurrentUser({
            ...userAuth,
            companyId: null, // Asignar null si no hay datos
          });
        }
      } else {
        // Usuario ha cerrado sesión
        setCurrentUser(null);
      }
      setLoading(false); // Marcar la carga como completa
    });

    // Limpiar el listener al desmontar
    return unsubscribe;
  }, []); // Ejecutar solo una vez al montar

  const value = {
    user: currentUser, // Usar 'user' para coincidir con useAuth
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children} {/* Renderizar hijos solo cuando la carga inicial haya terminado */}
    </AuthContext.Provider>
  );
}